import { render, staticRenderFns } from "./overviewFile.vue?vue&type=template&id=4e3927a8&scoped=true&"
import script from "./overviewFile.vue?vue&type=script&lang=js&"
export * from "./overviewFile.vue?vue&type=script&lang=js&"
import style0 from "./overviewFile.vue?vue&type=style&index=0&id=4e3927a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3927a8",
  null
  
)

export default component.exports